var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPotion1 = function SvgPotion1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 414 252"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#potion1_svg__a)",
    d: "M144.422 89.436c63.942-34.262 184.018-54.812 236.063-60.803-16.029 22.458-48.523 67.523-50.26 68.116-2.171.742-59.189 41.077-64.103 43.726-3.931 2.119-97.858 19.212-144.329 27.494L1.334 127.66c21.053 1.535 79.146-3.961 143.088-38.224"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#potion1_svg__b)",
    fillRule: "evenodd",
    d: "M.474 127.703c58.518 61.473 149.574 86.914 235.154 57.672 74.335-25.399 126.691-85.957 144.844-156.763-24.38 24.161-68.371 61.713-106.804 74.845-21.968 7.506-56.544 6.229-95.795 4.779-57.404-2.119-124.808-4.609-177.4 19.467",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "potion1_svg__a",
    x1: 186.383,
    x2: 213.994,
    y1: 64.898,
    y2: 141.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#9FCFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#99AEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#A293FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#C389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#E98EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F992D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FFA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#FFE0A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "potion1_svg__b",
    x1: 164.229,
    x2: 164.229,
    y1: 72.272,
    y2: 365.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#9FCFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#99AEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#A293FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#C389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#E98EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F992D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FFA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#FFE0A3"
  })))));
};
export default SvgPotion1;